export default __webpack_public_path__ + "locales/es/VersionHistory.json?hash=de75eb9dd9542173fc437114dedf0e04";